<template>
  <div class="">
    <hr>
    <p class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</p>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">


      <div class="text-center my-3" v-if="item.config.image != ''">
        <img class="image-input" :src="item.config.image" alt="">
      </div>


      <div class="custom-file text-left">
        <input @change="uploadImage" type="file" class="custom-file-input" id="customFile">


        <label class="custom-file-label" for="customFile">انتخاب عکس پیش فرض</label>
      </div>

      <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash"
              @click="deleteQuestion()"/>

    </div>

  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "ImageInput",
  components: {FormErrorsManager, FormGroup},
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    },

    async checkFormImageDirectory() {
      let req = await this.$store.dispatch('FileManager/setDirectories')
      let folders = req.data.data
      if (folders.indexOf('form-images') > -1) {
        return true
      }

      return false

    },

    async createFolder() {
      let checker = await this.checkFormImageDirectory()

      if (checker == false) { // create folder if not exists
        let form = {
          name: 'form-images'
        }
        let req = await this.$store.dispatch('FileManager/createDirectory', form)
      }
      return true
    },

    async uploadImage(e) {
      await this.createFolder()
      const file = e.target.files[0];

      let form = {
        uploadDirectory: 'form-images',
        selectedFiles: [file],
      }

      let req = await this.$store.dispatch('FileManager/uploadFiles', form)
      this.item.config.image = req.data.data[0]['file']


    },
  }
}
</script>

<style scoped>
.image-input {
  width: 150px;
  height: 150px;
  object-fit: contain;
}
</style>